import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgModelling = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.5 5H1C0.4 5 0 5.5 0 6V18.5C0 19.1 0.4 19.5 1 19.5H7.5C8.1 19.5 8.5 19.1 8.5 18.5V6C8.5 5.5 8.1 5 7.5 5ZM6.5 17.6H2V7H6.5V17.6ZM17.9 17.6H16.9H14.4H13.4V16.6H11.4V18.6C11.4 19.2 11.8 19.6 12.4 19.6H13.8H17.7H18.9C19.5 19.6 19.9 19.2 19.9 18.6V16.6H17.9V17.6ZM13.4 5.1H11.4V8.7H13.4V5.1ZM13.4 10.8H11.4V14.4H13.4V10.8ZM18.9 0H12.4C11.8 0 11.4 0.4 11.4 1V3H13.4V2H17.9V3H19.9V1C19.9 0.4 19.5 0 18.9 0ZM17.9 14.5H19.9V10.9H17.9V14.5ZM17.9 8.7H19.9V5.1H17.9V8.7Z",
		fill: "white"
	})
});
export default SvgModelling;
